import React from 'react';
import { useT } from '../../context/TenantContext';
import { LogoUNEA } from '../../components/common/Logo';

export default function FrontDeskLogin({ error }) {
  const { t } = useT();
  // Por defecto, vuelve a la página desde la que se pidió el login
  // (FrontDesk, RoomsPage, ExtensionsPage...), NO al panel de técnicos.
  // Antes caía en '/backdesk' por defecto, que está protegido para agentes:
  // alguien externo que solo quería usar el portal público acababa
  // redirigido a la pantalla de login de técnicos tras autenticarse con Google.
  const redirect = new URLSearchParams(window.location.search).get('redirect') || window.location.pathname || '/';
  function handleGoogleLogin() {
    window.location.href = '/api/auth/google?redirect=' + encodeURIComponent(redirect);
  }

  return (
    <div style={{
      minHeight: '100vh',
      background: 'url(/bg-frontdesk-login.jpg) center center / cover no-repeat',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      fontFamily: 'Inter, Arial, sans-serif', padding: '24px 16px',
    }}>
      <div style={{
        display: 'flex',
        width: '100%', maxWidth: 820,
        background: '#fff',
        borderRadius: 20,
        boxShadow: 'none',
        overflow: 'hidden',
        minHeight: 420,
      }}>

        {/* ── Columna izquierda — ilustración ── */}
        <div style={{
          flex: 1,
          background: '#F7F9FC',
          display: 'flex', flexDirection: 'column',
          alignItems: 'center', justifyContent: 'center',
          padding: '48px 40px',

        }}>
          {/* Ilustración SVG — red de nodos */}
          <img src="/login-illustration.svg" alt="" style={{width: 220, marginBottom: 28}}/>

          <h2 style={{
            fontSize: 18, fontWeight: 700, color: '#003D6B',
            marginBottom: 10, textAlign: 'center', lineHeight: 1.3,
          }}>
            Portal de Soporte TI
          </h2>
          <p style={{
            fontSize: 13, color: '#5B8DB8', textAlign: 'center',
            lineHeight: 1.7, maxWidth: 240, margin: 0,
          }}>
            Gestiona tus incidencias y solicitudes de soporte técnico de forma rápida y sencilla.
          </p>

          {/* Dots decorativos */}
          <div style={{display:'flex', gap:6, marginTop:28}}>
            {[0,1,2,3].map(i => (
              <div key={i} style={{
                width: i===1 ? 20 : 7, height: 7, borderRadius: 4,
                background: i===1 ? '#0085CA' : '#C5D8E8',
                transition: 'all .2s',
              }}/>
            ))}
          </div>
        </div>

        {/* ── Columna derecha — login ── */}
        <div style={{
          flex: 1,
          display: 'flex', flexDirection: 'column',
          alignItems: 'center', justifyContent: 'center',
          padding: '48px 40px',
        }}>
          {/* Logo */}
          <LogoUNEA height={60} style={{display:'block', marginBottom:20, maxWidth:240}}/>

          <h1 style={{
            fontSize: 17, fontWeight: 700, color: '#111827',
            marginBottom: 6, textAlign: 'center',
          }}>
            HelpDesk TI
          </h1>
          <p style={{
            fontSize: 13, color: '#9CA3AF', marginBottom: 32,
            textAlign: 'center', lineHeight: 1.5,
          }}>
            Accede con tu cuenta institucional
          </p>

          {/* Error */}
          {error && (
            <div style={{
              width: '100%', marginBottom: 18, padding: '10px 14px',
              borderRadius: 8, background: '#FEF2F2',
              border: '1px solid #FCA5A5',
              fontSize: 12, color: '#B91C1C', textAlign: 'center',
            }}>
              {error === 'domain'
                ? t('login.error_domain')
                : t('login.error')}
            </div>
          )}

          {/* Botón Google — único método de acceso */}
          <button
            onClick={handleGoogleLogin}
            style={{
              width: '100%', height: 46, borderRadius: 10,
              marginTop: 4,
              border: '1.5px solid #E5E7EB', background: '#fff',
              display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10,
              cursor: 'pointer', fontSize: 14, fontWeight: 600, color: '#374151',
              boxShadow: 'none',
              transition: 'all .15s',
            }}
            onMouseOver={e => { e.currentTarget.style.borderColor='#0085CA'; e.currentTarget.style.boxShadow='none'; }}
            onMouseOut={e => { e.currentTarget.style.borderColor='#E5E7EB'; e.currentTarget.style.boxShadow='0 1px 4px rgba(0,0,0,.08)'; }}
          >
            <svg width="20" height="20" viewBox="0 0 24 24">
              <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
              <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
              <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z"/>
              <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
            </svg>
            Iniciar sesión con Google
          </button>


        </div>

      </div>
    </div>
  );
}
